module.exports = __webpack_public_path__ + "sv.svg?b620d58e00f5ba252bc526a45750a9e6";